import React from 'react';
import merge from 'lodash/merge';
import { Steps } from './steps/Steps';
import { Providers } from './components/Providers';
import type { RsiProps } from './types';
import { ModalWrapper } from './components/ModalWrapper';

function noop() {}

export const defaultRSIProps: Partial<RsiProps<any>> = {
  allowInvalidSubmit: true,
  autoMapDistance: 2,
  autoMapHeaders: true,
  autoMapSelectValues: false,
  dateFormat: 'yyyy-mm-dd', // ISO 8601,
  isNavigationEnabled: false,
  matchColumnsStepHook: async (table) => table,
  parseRaw: true,
  selectHeaderStepHook: async (headerValues, data) => ({ headerValues, data }),
  uploadStepHook: async (value) => value,
  onTrackUserEvent: noop,
  matcherIgnorePrefixes: [],
  translations: {}
} as const;

export const ReactSpreadsheetImport = <T extends string>(props: RsiProps<T>) => {
  const mergedProps = merge({}, defaultRSIProps, props);
  return (
    <Providers rsiValues={{ ...mergedProps }} translations={props.translations ?? {}}>
      <ModalWrapper isOpen={mergedProps.isOpen} onClose={mergedProps.onClose}>
        <Steps />
      </ModalWrapper>
    </Providers>
  );
};
